import React from 'react';
import PropTypes from 'prop-types';

const ViewMoreSelector = ({ textViewMore, onClick }) => (
    <div className="card__view-more" aria-hidden="true" onClick={() => onClick()}>
        {textViewMore}
    </div>
);
ViewMoreSelector.propTypes = {
    textViewMore: PropTypes.any,
    onClick: PropTypes.func,
};
export default ViewMoreSelector;
